import React, { useEffect } from 'react';
import { View } from 'react-native';
import Animated, {
  useAnimatedStyle,
  useReducedMotion,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

export interface SkeletonProps {
  /** Size the block with utility classes, e.g. "h-4 w-32". */
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  const reducedMotion = useReducedMotion();
  const opacity = useSharedValue(0.45);

  useEffect(() => {
    if (!reducedMotion) {
      opacity.value = withRepeat(withTiming(0.9, { duration: 750 }), -1, true);
    }
  }, [opacity, reducedMotion]);

  const animatedStyle = useAnimatedStyle(() => ({ opacity: opacity.value }));

  return (
    <Animated.View style={animatedStyle}>
      <View className={`rounded-lg bg-surface-2${className ? ` ${className}` : ''}`} />
    </Animated.View>
  );
}
